import React, { useEffect } from "react";

interface IUseImageSizes {
  src: string;
  width?: string;
  height?: string;
  setSizes: (props: { width: string; height: string }) => void;
}

const useImageSizes = ({ src, width, height, setSizes }: IUseImageSizes) => {
  useEffect(() => {
    if (width) return () => {};

    const image = new globalThis.Image();
    let poll;

    const supportsNatural = "naturalWidth" in new globalThis.Image();

    image.onerror = () => {
      globalThis.clearInterval(poll);
    };

    if (supportsNatural) {
      poll = globalThis.setInterval(() => {
        if (image.naturalWidth) {
          setSizes({
            width: String(image.naturalWidth),
            height: String(image.naturalHeight),
          });

          globalThis.clearInterval(poll);
        }
      }, 50);
    }

    image.src = src;

    return () => {
      globalThis.clearInterval(poll);
    };
  }, [width, height]);
};

export default useImageSizes;
